// Product gallery: thumbnail click, mouse-wheel scroll, and swipe all switch the main image
document.querySelectorAll('.gallery-main').forEach(function (galleryMain) {
  const wrap = galleryMain.closest('.product-hero') || document;
  const mainImgs = Array.from(galleryMain.querySelectorAll('img'));
  const thumbs = Array.from(wrap.querySelectorAll('.thumb'));
  let current = 0;

  function showImage(i) {
    current = (i + mainImgs.length) % mainImgs.length;
    mainImgs.forEach((img, idx) => img.classList.toggle('active', idx === current));
    thumbs.forEach((t, idx) => t.classList.toggle('active', idx === current));
  }
  showImage(0);

  thumbs.forEach((t, idx) => t.addEventListener('click', () => showImage(idx)));

  let wheelLock = false;
  galleryMain.addEventListener('wheel', (e) => {
    if (mainImgs.length < 2) return;
    e.preventDefault();
    if (wheelLock) return;
    wheelLock = true;
    showImage(current + (e.deltaY > 0 ? 1 : -1));
    setTimeout(() => (wheelLock = false), 380);
  }, { passive: false });

  let touchStartY = null;
  galleryMain.addEventListener('touchstart', (e) => (touchStartY = e.touches[0].clientY), { passive: true });
  galleryMain.addEventListener('touchend', (e) => {
    if (touchStartY === null || mainImgs.length < 2) return;
    const diff = touchStartY - e.changedTouches[0].clientY;
    if (Math.abs(diff) > 40) showImage(current + (diff > 0 ? 1 : -1));
    touchStartY = null;
  });
});

// Simple AJAX add-to-cart so the design never has to leave the page unexpectedly
document.querySelectorAll('[data-product-form]').forEach((formEl) => {
  formEl.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = formEl.querySelector('[data-add-to-cart]');
    const originalText = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;
    try {
      const formData = new FormData(formEl);
      const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
      if (!res.ok) throw new Error('Add to cart failed');
      btn.textContent = 'Added ✓';
      setTimeout(() => {
        window.location.href = '/cart';
      }, 500);
    } catch (err) {
      btn.textContent = 'Try again';
      btn.disabled = false;
      console.error(err);
    }
  });
});
